function GroupChatIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
    >
      <path
        d="M2.71641 7.5C2.71641 6.94772 3.16412 6.5 3.71641 6.5H16.9164C17.4687 6.5 17.9164 6.94772 17.9164 7.5V17.5C17.9164 18.0523 17.4687 18.5 16.9164 18.5H3.82791H3.71641C3.16412 18.5 2.71641 18.0523 2.71641 17.5V7.5ZM2.71641 4.5C1.67141 4.5 0.825906 5.4 0.825906 6.5L0.817729 21.9935C0.817252 22.8971 1.92039 23.3379 2.54273 22.6828L4.32072 20.8113C4.50951 20.6125 4.77161 20.5 5.04572 20.5H17.9164C18.9614 20.5 19.8164 19.6 19.8164 18.5V6.5C19.8164 5.4 18.9614 4.5 17.9164 4.5H2.71641ZM4.61641 15.5C4.61641 14.9477 5.06412 14.5 5.61641 14.5H15.0164C15.5687 14.5 16.0164 14.9477 16.0164 15.5C16.0164 16.0523 15.5687 16.5 15.0164 16.5H5.61641C5.06412 16.5 4.61641 16.0523 4.61641 15.5ZM4.61641 12.5C4.61641 11.9477 5.06412 11.5 5.61641 11.5H15.0164C15.5687 11.5 16.0164 11.9477 16.0164 12.5C16.0164 13.0523 15.5687 13.5 15.0164 13.5H5.61641C5.06412 13.5 4.61641 13.0523 4.61641 12.5ZM4.61641 9.5C4.61641 8.94772 5.06412 8.5 5.61641 8.5H15.0164C15.5687 8.5 16.0164 8.94772 16.0164 9.5C16.0164 10.0523 15.5687 10.5 15.0164 10.5H5.61641C5.06412 10.5 4.61641 10.0523 4.61641 9.5Z"
        fill="black"
      />
      <path
        d="M19.3164 1.5C21.2494 1.5 22.8164 3.067 22.8164 5C22.8164 6.933 21.2494 8.5 19.3164 8.5C17.3834 8.5 15.8164 6.933 15.8164 5C15.8164 3.067 17.3834 1.5 19.3164 1.5Z"
        fill="#F76241"
        stroke="white"
        strokeWidth="2"
      />
    </svg>
  );
}

export default GroupChatIcon;
